export default function Japan() {
  return (
    <>
      <section className="hero">
        <div className="container">
          <h1 lang="ja">日本の高齢者の孤独を終わらせる</h1>
          <p className="lead" lang="ja">
            MyJava.aiが実績あるピアサポート技術を日本へ。
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 lang="ja">日本向けソリューション</h2>
          <p lang="ja">
            世界で1,500万人以上の高齢者が一人暮らしをしており、日本は世界で最も急速に高齢化が進む国の一つです。
            MyJava.aiは実証済みのソリューションを提供します。私たちのAI音声技術「Bella（ベラ）」は、
            親密なピアサポートグループを促進し、孤立した高齢者をつなぎ、共通の経験を通じて意味のある関係を築くお手伝いをします。
          </p>

          <div className="grid three" style={{ marginTop: 32 }}>
            <div className="card">
              <h3 lang="ja">音声ファースト技術</h3>
              <p lang="ja">電話やスマートスピーカーで簡単アクセス — アプリや複雑な操作は不要。</p>
            </div>
            <div className="card">
              <h3 lang="ja">AIファシリテーター「Bella」</h3>
              <p lang="ja">グループセッションで全ての参加者が大切にされていると感じられるようサポート。</p>
            </div>
            <div className="card">
              <h3 lang="ja">実証された成果</h3>
              <p lang="ja">北米で10年以上、2,000以上の高齢者施設にサービスを提供。</p>
            </div>
          </div>

          <h2 style={{ marginTop: 56 }} lang="ja">なぜ日本にMyJava.aiが必要か</h2>
          <p lang="ja">
            技術の進歩と伝統への敬意を兼ね備えた日本は、MyJava.aiの「ローテクユーザーのためのハイテクソリューション」に
            最適な市場です。私たちのアプローチは、高齢者の知恵と経験を尊重しながら、
            最先端のAIを活用して意味のあるつながりを促進します。
          </p>
        </div>
      </section>
    </>
  );
}
